<script>
import formatDate from '@utils/format-date'

export default {
  props: {
    currentOrder: {
      type: Object,
      default: () => { },
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showAllStatus: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      submitData: {
        refundDate: formatDate(new Date(), 'date-dash'),
        amount: this.currentOrder.recommendRefundValue.amount,
        note: '',
        paymentMethod: '',
        bonus: this.currentOrder.recommendRefundValue.bonus,
      },
      bonusDialog: false,
      containerInfo: {}, // 這個container的Info
      allPageLoading: false, // 這個頁面的loading
    }
  },
  computed: {
    /**
     * @description 驗證是否可以出現信用卡退款選項
     */
    validateCreditRefundDate() {
      if (Object.keys(this.currentOrder).length > 0) {
        const { paidAt } = this.currentOrder
        return this.isWithin90DaysFromPaidDate(paidAt);
      }
      return true
    },
    submitRules() {
      return {
        refundDate: [
          {
            required: true,
            message: '請選擇日期',
          },
        ],
        amount: [
          {
            required: true,
            message: '請輸入退款金額',
            type: 'number'
          },
          { validator: this.validateValue, trigger: 'blur' }
        ],
        bonus: [
          {
            message: '請輸入退款金額',
            type: 'number'
          },
          { validator: this.validateValue, trigger: 'blur' }
        ],
        paymentMethod: [
          {
            required: true,
            message: '請選擇退款方式',
          }
        ],
      }
    },
    canPartialRefund() {
      return this.currentOrder.canPartialRefund
    },
    summary() {
      return parseInt(this.submitData.amount) + parseInt(this.submitData.bonus)
    },
    /**
     * @description 付款方式是否是儲值金
     */
    userSelectDepositPayment() {
      return this.submitData.paymentMethod === 'Deposit'
    },
    /**
     * @description containerInfo 是否有值了‘
     */
    containerInfoKeyLength() {
      return Object.keys(this.containerInfo).length > 0
    }
  },
  watch: {
    currentOrder() {
      this.setSubmitData()
    }
  },
  async mounted() {
    await this.getOrderContainerInfo()
  },
  methods: {
    isWithin90DaysFromPaidDate(paidAt) {
      // 将 paidAt 解析为日期对象
      const paidDate = new Date(paidAt);
      // 获取今天的日期
      const today = new Date();
      // 计算 paidAt 之后 90 天的日期
      const futureDate = new Date(paidDate);
      futureDate.setDate(futureDate.getDate() + 90);
      // 检查是否 paidAt 之后的日期在今天之前
      return today <= futureDate;
    },
    validateValue(rule, value, callback) {
      if (value >= 0) {
        callback();
      } else {
        callback(new Error('數值必須大於等於0'));
      }
    },
    async getOrderContainerInfo() {
      try {
        if (this.showAllStatus) {
          this.allPageLoading = true
          const { orderContainerUuid } = this.currentOrder
          this.containerInfo = await this.$store.dispatch('order/fetchContainerList', orderContainerUuid)
          this.$set(this.submitData, 'amount', this.containerInfo.recommendRefundValue.amount || 0)
          this.$set(this.submitData, 'bonus', this.containerInfo.recommendRefundValue.bonus || 0)
        }
      } catch (error) {
        console.error(error.message)
      } finally {
        this.allPageLoading = false
      }

    },
    setSubmitData() {
      if (this.showAllStatus) {
        this.$set(this.submitData, 'amount', this.containerInfo.recommendRefundValue.amount || 0)
        this.$set(this.submitData, 'bonus', this.containerInfo.recommendRefundValue.bonus || 0)
      } else {
        const { recommendRefundValue } = this.currentOrder
        this.$set(this.submitData, 'amount', recommendRefundValue.amount || 0)
        this.$set(this.submitData, 'bonus', recommendRefundValue.bonus || 0)
      }

    },
    onSelectRefundPaymentMethod(paymentMethod) {
      if (paymentMethod === 'Credit' && !this.canPartialRefund)
        this.submitData.amount = this.currentOrder.backBalance
    },
    async onClickRefund() {
      await this.$refs.form.validate()
      this.$emit('submit', this.submitData)
    },
    onClickClose() {
      this.$emit('close')
    },
    openBonus() {
      this.bonusDialog = true
    },
  },
}
</script>
<template>
  <div v-loading="allPageLoading" :class="$style.orderformSection">
    <el-form ref="form" :rules="submitRules" :model="submitData" class="el-form--floating el-form-item--white-bg"
      label-position="top">
      <el-form-item label="退款方式" prop="paymentMethod">
        <el-select v-model="submitData.paymentMethod" @change="onSelectRefundPaymentMethod">
          <template v-if="currentOrder.paymentMethod !== 'Deposit'">
            <el-option label="到店付款(現金)" value="Cash">
            </el-option>
            <el-option label="線下匯款" value="Atm">
            </el-option>
            <el-option v-if="currentOrder.paymentMethod === 'StoreCredit'" label="現場刷卡" value="StoreCredit">
            </el-option>
            <el-option v-if="currentOrder.paymentMethod === 'Credit' && validateCreditRefundDate" label="信用卡付款"
              value="Credit">
            </el-option>
          </template>

          <el-option v-if="$hasDeposit()" label="儲值金" value="Deposit">
          </el-option>

        </el-select>
      </el-form-item>

      <el-row :gutter="20">
        <el-col v-if="submitData.paymentMethod === 'Deposit'" :span="8">
          <el-form-item label="客戶實收退款" prop="summary">
            <el-input v-model="summary" :disabled="true" placeholder=""
              :class="[userSelectDepositPayment ? $style.actualRefund : '']"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="submitData.paymentMethod === 'Deposit' ? 8 : 24">
          <el-form-item label="收款金額" prop="amount">
            <el-input v-model.number="submitData.amount" type="number"
              :disabled="!canPartialRefund && submitData.paymentMethod === 'Credit'" placeholder=""
              :class="[userSelectDepositPayment ? $style.refundMoney : '']"><span slot="suffix"
                style="padding-right: 10px">元</span></el-input>
            <span v-if="!userSelectDepositPayment && containerInfoKeyLength" class="alert-word">上限為{{
              containerInfo.recommendRefundValue.amount
            }}元</span>
          </el-form-item>
        </el-col>
        <el-col v-if="submitData.paymentMethod === 'Deposit'" :span="8">
          <el-form-item label="加碼點數" prop="bonus">
            <span slot="label">
              <span @click="openBonus" :class="$style.bonusStyle">
                <span>加碼點數</span>
                <span :class="$style['bonusStyle__spanStart']">* </span>
                <BaseIcon slot="label-suffix" name="info-circle" :class="$style['bonusStyle__icon']" />
              </span>
            </span>
            <el-input type="number" v-model.number="submitData.bonus" placeholder=""><span slot="suffix"
                style="padding-right: 10px">點</span></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="userSelectDepositPayment">
        <span class="normal-word">加碼點數僅供折抵消費使用，</span>
        <span class="alert-word">無法退款為現金</span>
      </el-row>

      <el-form-item label="退款日期" prop="refundDate">
        <el-date-picker v-model="submitData.refundDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          placeholder="選擇日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="退款原因" style="margin-bottom: 20px">
        <el-input v-model="submitData.note" type="textarea" :rows="5" placeholder="請詳細說明"
          class="is-border is-round"></el-input>
      </el-form-item>
    </el-form>
    <p class="text-seconary">除「信用卡」付款之外，其他所有支付方式若需退款服務，皆須透過店家進行線下退款。</p>
    <div class="bottom-btn-center d-flex">
      <el-button class="is-round w-100" @click="onClickClose">取消</el-button>
      <el-button class="is-round w-100" type="primary" :loading="loading" @click="onClickRefund">確認退款</el-button>
    </div>
    <el-dialog title="加碼點數" width="550px" :visible.sync="bonusDialog" top="0" append-to-body destroy-on-close>
      <div :class="$style.dialogBonus">
        <div :class="$style['dialogBonus__text']">
          <span>儲值點數分為一般預付金額（實收金額）及店家贈送（加碼點 數）兩部分組成，使用時系統會優先使用客戶預付的部份。當客 戶欲結清儲值點數全數退款時，因加碼點數為店家贈送招待則</span>
          <span :class="$style['dialogBonus__redText']">無法退為現金。</span>
        </div>
        <div :class="$style['dialogBonus__text']">
          <span>例：儲值500元可用600點 = 實收金額500元 + 加碼點數100點 <br>客戶在使用400點後，剩餘的部分為200點 = 實收金額100元 +
            加碼點數100點，則最終客戶可退的金額為100元</span>
        </div>
        <el-button type="primary" class="is-round" @click="(bonusDialog = false)">確認</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }
    }
  }
}

.actualRefund {
  display: flex;

  &::after {
    content: ' =';
    margin-left: 10px;
    position: absolute;
    right: -16px;
    color: black;
  }
}

.refundMoney {
  display: flex;

  &::after {
    content: ' +';
    margin-left: 10px;
    position: absolute;
    right: -16px;
    color: black;
  }
}

.dialogBonus {
  display: flex;
  flex-direction: column;

  &__text {
    font-size: 14px;
    color: #404040;
    line-height: 26px;
    padding: 10px;

    &:first-child {
      border-bottom: 2px $color-line-dark dashed;
    }

    &:last-child {
      margin-bottom: 10px;
    }
  }

  &__redText {
    color: $color-primary !important;
  }
}

.bonusStyle {
  &__spanStart {
    color: red;
  }

  &__icon {
    color: $color-text-light;
  }
}
</style>